import * as theme from "../theme";
import Select from "react-dropdown-select";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOperationsList,
  getOperationsSelected,
  loadOperations,
  operationSelected,
} from "../store/operations";
import { getProductList, loadProducts } from "../store/products";
import { loadBrokerageInsurers } from "../store/insurers";
import { getBrokerFirstName, getBrokerInformation } from "../store/broker";
import { makeStyles } from "@material-ui/core/styles";
import {
  changeHelpOrTipText,
  changeShowRecentQuotesTable,
  getLanguageCode,
  getRecentQuotes,
  getRecentQuotesArray,
  getShowRecentQuotesTable,
} from "../store/components";
import WhatSortOfProduct from "./WhatSortOfProduct";
import _ from "lodash";
import CreateProspectButton from "./CreateProspectButton";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { Client_Business_name, Client_Name } from "../store/permanentQues";
import { OrangeButton } from "./OrangeButton";
import { getMyQuotes, getRowDetailsFromProspectId } from "../store/myquotes";
import { capitalizeFirstLetter } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import translations from "../utils/translations";

const useStyles = makeStyles({
  responses: {
    "&::-webkit-scrollbar": {
      width: theme.SCALES.scrollbarThickness,
      backgroundColor: "inherit",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: theme.COLORS.little_darker_lightindigo,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.COLORS.primary_navyblue,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.COLORS.primary_navyblue,
    },
  },
});

const removeAccents = (str) => {
  return str
    .normalize("NFD") // Decompose combined letters into base letters and diacritics
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritic marks
    .toLowerCase(); // Convert to lowercase for case-insensitive matching
};
const WelcomeBackLeftPane = () => {
  const currentOperations = useSelector(getOperationsSelected);
  const dispatch = useDispatch();
  const operations = useSelector(getOperationsList);
  const brokerFirstName = useSelector(getBrokerFirstName);
  const languagecode = useSelector(getLanguageCode);
  console.log("show lang code", languagecode);
  console.log("show operation", operations);
  const showRecentQuotesTable = useSelector(getShowRecentQuotesTable);
  const products = useSelector(getProductList);
  const navigate = useNavigate();
  const classes = useStyles();
  const brokerage = useSelector(getBrokerInformation);
  const brokerageCode = brokerage?.information?.brokeragecode;
  const enhancedOperations = operations.map((option) => ({
    ...option,
    normalizedLabel: removeAccents(option.name[languagecode] || ""),
  }));

  const customSearchFn = (options, searchTerm) => {
    const normalizedSearchTerm = removeAccents(searchTerm || "").trim();

    if (normalizedSearchTerm === "") {
      return options;
    }

    return options.filter((option) =>
      option.normalizedLabel.includes(normalizedSearchTerm)
    );
  };

  const handleSearch = (options, searchTerm) => {
    return customSearchFn(options, searchTerm);
  };

  // On operation selected
  const onChangeHandle = (value) => {
    dispatch(operationSelected(value));
  };
  useEffect(() => {
    dispatch(operationSelected([]));
  }, []);

  const regexSearchIncludance = (item, languagecode) => {
    return (
      item["name"][languagecode] +
      " " +
      item["vertical"]["name"][languagecode] +
      " " +
      item["description"][languagecode]
    );
  };

  const dropdownRenderer = ({ props, state, methods }) => {
    const regexp = new RegExp(
      state.search.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"),
      "i"
    );
    let rows = props.options
      .filter((item) => {
        if (currentOperations.length > 0)
          return (
            regexp.test(regexSearchIncludance(item, languagecode)) &&
            item["vertical"].id === currentOperations[0].verticalid
          );
        else return regexp.test(regexSearchIncludance(item, languagecode));
      })
      .map((item, index) => (
        <EachRowRender
          key={index}
          index={index}
          cursor={state.cursor}
          item={item}
          methods={methods}
          selected={methods.isSelected(item)}
        ></EachRowRender>
      ));

    return (
      <div style={{ height: "100vh" }}>
        <div className={classes.responses} style={{ height: "100vh" }}>
          {rows}
        </div>
      </div>
    );
  };

  function EachRowRender(props) {
    const item = props.item;
    const methods = props.methods;
    const index = props.index;
    let { information } = useSelector(getBrokerInformation);
    const languagepreference = information.languagepreference;
    const getColorAccordingtoIndex = (index) => {
      if (index % 2 === 0) {
        return theme.COLORS.tertiary_lightbackground;
      } else return "white";
    };

    const [bgcolor, setBgcolor] = useState(
      methods.isSelected(item)
        ? theme.COLORS.little_darker_lightindigo
        : getColorAccordingtoIndex(index)
    );

    const changeBgColor = (color) => {
      if (methods.isSelected(item)) {
      } else {
        setBgcolor(color);
      }
    };

    const EachRowRenderFncs = {
      backgrondChangeFn: {},
      references: {},
    };

    useEffect(() => {
      EachRowRenderFncs.backgrondChangeFn[index] = changeBgColor;
    });

    return (
      <div
        style={{
          backgroundColor: methods.isSelected(item)
            ? theme.COLORS.tertiary_ligthindigo
            : bgcolor,
          height: "70px",
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginBottom: 2,
          fontFamily: "GibsonRegular",
        }}
        onClick={() => {
          methods.addItem(item);
        }}
        onMouseOver={() => {
          setBgcolor(theme.COLORS.secondary_orange);
          dispatch(changeHelpOrTipText(item["description"][languagecode]));
        }}
        onMouseLeave={() => {
          changeBgColor(getColorAccordingtoIndex(index));
        }}
      >
        <div
          style={{
            width: "67%",
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "flex-start",
            padding: 10,
            fontSize: 18,
            paddingLeft: "5%",
          }}
        >
          {item.name[languagecode]}
        </div>

        <div
          style={{
            width: "33%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              backgroundColor: getColorAccordingtoIndex(index + 1),
              color: theme.COLORS.primary_navyblue,
              borderRadius: 15,
              padding: 5,
              fontSize: 15,
            }}
          >
            {item.vertical.name[languagecode]}
          </div>
        </div>
      </div>
    );
  }

  const commonStyleForTableBox = {
    border: "5px solid white",
    borderRadius: 10,
    backgroundColor: theme.COLORS.help_tip,
    width: "100%",
    boxShadow: "0px 0 30px 0px #AFB6CC",
    paddingLeft: 20,
    paddingRight: 20,
  };

  useEffect(() => {
    dispatch(loadOperations(brokerageCode));
    dispatch(loadProducts());
    dispatch(loadBrokerageInsurers(brokerageCode));
  }, [dispatch]);

  const recentQuotesHeaderHeight = "15%";
  const showButtonHeight = "9%";
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "25%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          paddingLeft: "17%",
          paddingRight: "0%",
        }}
      >
        {/* section 1.1 welcome back nick */}
        <div
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: "1.9vw",
            color: theme.COLORS.primary_navyblue,
            display: "flex",
          }}
        >
          {translations[languagecode].welcomeBack} {" " + brokerFirstName + "!"}
        </div>
        <div style={{ height: "10%" }}></div>

        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          <div style={{ width: "80%" }}>
            <Select
              multi
              placeholder={translations[languagecode].whatTypeOfBusiness}
              color={theme.COLORS.primary_navyblue}
              searchable={true}
              onChange={(values) => onChangeHandle(values)}
              values={[]}
              options={enhancedOperations}
              style={{
                width: "100%",
                height: "6vh",
                fontSize: "1.9vmin",
                border: "5px solid white",
                borderRadius: 15,
                fontFamily: "GibsonRegular",
              }}
              searchFn={handleSearch}
              dropdownRenderer={dropdownRenderer}
              labelField={`name.${languagecode}`}
              valueField={"id"}
              dropdownHeight={"58vh"}
              onDropdownClose={() => {
                dispatch(changeShowRecentQuotesTable(true));
                dispatch(changeHelpOrTipText(""));
              }}
              onDropdownOpen={() => {
                dispatch(changeShowRecentQuotesTable(false));
              }}
            />
          </div>
          <div
            style={{
              width: "20%",
              paddingLeft: "3%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {_.isEmpty(currentOperations) ? null : (
              <Button
                style={{
                  color: "white",
                  height: "3.5vh",
                  fontFamily: "GibsonSemiBd",
                  fontSize: 12,
                  backgroundColor: theme.COLORS.secondary_skyblue,
                  marginTop: 5,
                  marginLeft: 10,
                  border: 0,
                  width: "5vw",
                  letterSpacing: 1,
                }}
              >
                {translations[languagecode].next}
              </Button>
            )}
          </div>
        </div>
      </div>

      {showRecentQuotesTable ? (
        <div
          style={{
            width: "100%",
            height: "75%",
            paddingLeft: "15%",
            paddingRight: "15%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {_.isEmpty(currentOperations) ? (
            <div
              style={{
                height: "80%",
                ...commonStyleForTableBox,
              }}
            >
              <div
                style={{
                  fontFamily: "GibsonSemiBd",
                  color: theme.COLORS.secondary_skyblue,
                  marginLeft: "1%",
                  letterSpacing: 1,
                  fontSize: "max(1.1vw,1.1vh)",
                  height: recentQuotesHeaderHeight,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {translations[languagecode].recentProspects}
              </div>
              <div
                style={{
                  width: "100%",
                  height: `calc(100% - ${recentQuotesHeaderHeight} - ${showButtonHeight})`,
                }}
              >
                <RecentQuotesTable></RecentQuotesTable>
              </div>
              <div
                style={{
                  height: showButtonHeight,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <OrangeButton
                  onClick={() => {
                    //navigate(`/myquotes`)
                    document.location.href = `/myquotes`;
                  }}
                  fontSize="1.5vh"
                  text={translations[languagecode].showMore}
                  color={theme.COLORS.secondary_skyblue}
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                height: "90%",
                ...commonStyleForTableBox,
              }}
            >
              <WhatSortOfProduct products={products}></WhatSortOfProduct>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

const RecentQuotesTable = () => {
  // call the api
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;

  useEffect(() => {
    dispatch(getRecentQuotes({ limit: 5 }));
  }, [dispatch]);

  const recentquotes = useSelector(getRecentQuotesArray);

  const recentQuotesDecider = (recentquotes) => {
    if (typeof recentquotes === "string") return [];

    if (!_.isEmpty(recentquotes)) return recentquotes;

    return [];
  };
  const columnWidths = {
    first: "20%",
    second: "20%",
    third: "20%",
    fourth: "20%",
    fifth: "20%",
  };
  const headers = {
    first: "DATE",
    second: "CLIENT",
    third: "COMPANY",
    fourth: "STATUS",
    fifth: "ACTION",
  };
  const headersFr = {
    first: "DATE",
    second: "CLIENT",
    third: "COMPAGNIES",
    fourth: "Statut",
    fifth: "ACTION",
  };

  const commonStyleHeaders = {
    height: "100%",
  };

  const selectedLanuageHeaders =
    languagepreference === "fr" ? headersFr : headers;

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "16%",
          display: "flex",

          borderBottom: "1px solid lightgrey",
        }}
      >
        {/* HEADER ROWS */}
        <div
          style={{
            width: columnWidths.first,
            ...commonStyleHeaders,
          }}
        >
          <HeaderFiller text={selectedLanuageHeaders.first}></HeaderFiller>
        </div>
        <div
          style={{
            width: columnWidths.second,
            ...commonStyleHeaders,
          }}
        >
          <HeaderFiller text={selectedLanuageHeaders.second}></HeaderFiller>
        </div>
        <div
          style={{
            width: columnWidths.third,
            ...commonStyleHeaders,
          }}
        >
          <HeaderFiller text={selectedLanuageHeaders.third}></HeaderFiller>
        </div>
        <div
          style={{
            width: columnWidths.fourth,
            ...commonStyleHeaders,
          }}
        >
          <HeaderFiller text={selectedLanuageHeaders.fourth}></HeaderFiller>
        </div>
        <div
          style={{
            width: columnWidths.fifth,
            ...commonStyleHeaders,
          }}
        >
          <HeaderFiller text={selectedLanuageHeaders.fifth}></HeaderFiller>
        </div>
      </div>
      {recentQuotesDecider(recentquotes).map((item, index) => (
        <OneRow key={index} item={item} columnWidths={columnWidths}></OneRow>
      ))}
    </div>
  );
};

const OneRow = (props) => {
  const columnWidths = props.columnWidths;
  const item = props.item;
  const commonProperties = {
    height: "100%",
  };
  const statusTranslations = {
    New: {
      fr: "Nouveau",
    },
    "App In Progress": {
      fr: "En cours",
    },
    "Close - Incomplete info": {
      fr: "Fermé - Informations incomplètes",
    },
    "App Completed": {
      fr: "Application terminée",
    },
    "In Market": {
      fr: "Sur le marché",
    },
    "Close - No Insurer": {
      fr: "Fermé - Aucun assureur",
    },
    Quoted: {
      fr: "Devis fourni",
    },
    "Not Interested": {
      fr: "Pas intéressé",
    },
    Sold: {
      fr: "Vendu",
    },
  };

  function translateStatus(status, langPref) {
    if (statusTranslations[status] && statusTranslations[status][langPref]) {
      return statusTranslations[status][langPref];
    } else {
      // Handle cases where the status or language preference is not found
      console.warn(
        `No translation found for status "${status}" and language "${langPref}". Returning original status.`
      );
      return status; // Or you could return a default translation
    }
  }
  console.log("whstd history", item.lastupdated);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100%",
        height: "14%",
        display: "flex",
        borderBottom: "1px solid lightgrey",
      }}
    >
      <div style={{ ...commonProperties, width: columnWidths.first }}>
        <CellFiller
          text={
            item?.lastupdated
              ? moment(new Date(item.lastupdated), "DD/MM/YYYY")
                  .locale(languagepreference)
                  .format("DD MMM YYYY")
              : ""
          }
        ></CellFiller>
      </div>
      <div style={{ ...commonProperties, width: columnWidths.second }}>
        <CellFiller text={item[Client_Name]}></CellFiller>
      </div>
      <div style={{ ...commonProperties, width: columnWidths.third }}>
        <CellFiller text={item[Client_Business_name]}></CellFiller>
      </div>
      <div style={{ ...commonProperties, width: columnWidths.fourth }}>
        <CellFiller
          text={translateStatus(
            capitalizeFirstLetter(item.status),
            languagepreference
          )}
        ></CellFiller>
      </div>
      <div style={{ ...commonProperties, width: columnWidths.fifth }}>
        <CellFiller
          text={
            <Button
              style={{
                color: "white",
                fontFamily: "GibsonLight",
                fontSize: 12,
                borderColor: theme.COLORS.primary_navyblue,
                backgroundColor: theme.COLORS.primary_navyblue,
                borderRadius: 15,
              }}
              variant="secondary"
              onClick={() => {
                //navigate(`/prospect?id=${item.prospectid}`);
                document.location.href = `/prospect?id=${item.prospectid}`;
              }}
            >
              {translations[languagepreference].review}
            </Button>
          }
        ></CellFiller>
      </div>
    </div>
  );
};

const CellFiller = (props) => {
  const text = props.text;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        letterSpacing: 1,
        fontFamily: "GibsonRegular",
        color: theme.COLORS.grey_font_header,
        fontSize: "min(1.5vw,1.5vh)",
      }}
    >
      {text}
    </div>
  );
};

const HeaderFiller = (props) => {
  const text = props.text;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        letterSpacing: 1,
        fontFamily: "GibsonSemiBd",
        color: theme.COLORS.grey_font_header,
        fontSize: "min(1.5vw,1.5vh)",
      }}
    >
      {text}
    </div>
  );
};

export default WelcomeBackLeftPane;
